export const serializeDate = (yourDate: Date) => {
  // const offset = yourDate.getTimezoneOffset();
  // yourDate = new Date(yourDate.getTime() - offset * 60 * 1000);
  return yourDate.toLocaleDateString('fr-CA');
};
